module.exports = __webpack_public_path__ + "static/media/Panorama-An-extinct-volcanic-crater.90f2388a.jpg";